import React from "react";
import DocumentCard from "./DocumentCard";
import DocumentHistoryCard from "./DocumentHistoryCard";

const DocumentsList = ({
  documents = [],
  refetch,
  refreshProgressJourney = () => { },
  onVerificationAction,
  viewType = "documents",
  IsFinalApproved = false,
  isStudent = false,
}) => {

  return (
    <div className="space-y-4">
      <div className="space-y-3">
        <div className="flex items-center gap-2">
          <h3 className="text-base font-semibold text-gray-900 dark:text-dark-50">
            {viewType === "documents" ? "All Documents" : "Document History"}
          </h3>
          <span className="rounded-full bg-gray-100 px-3 py-1 text-xs font-medium text-gray-600 dark:bg-dark-600 dark:text-dark-100">
            {documents.length}
          </span>
        </div>

        {documents.length > 0 ? (
          <div className="space-y-4">
            {documents.map((document) => {
              return viewType === "documents" ? (
                <DocumentCard
                  key={document.id}
                  document={document}
                  refetch={refetch}
                  refreshProgressJourney={refreshProgressJourney}
                  onVerificationAction={onVerificationAction}
                  IsFinalApproved={IsFinalApproved}
                  isStudent={isStudent}
                />
              ) : (
                <DocumentHistoryCard
                  key={document.DocumentId}
                  document={document}
                />
              );
            })}
          </div>
        ) : (
          <div className="rounded-lg border border-dashed border-gray-200 px-4 py-6 text-sm text-gray-500 dark:border-dark-600 dark:text-dark-300">
            {viewType === "documents" ? "No documents found." : "No document history found."}
          </div>
        )}
      </div>
    </div>
  );
};

export default DocumentsList;
